export const REDUX_STORE_HOME = 'add_upcontent_source'
export const SOURCE_NAME = 'UpContent'
